import { 
	PhoenixToggleService, 
	FeatureService,
	AuthService 
} from 'phoenix/services';
import { 
	PhoenixUser,
	isPhoenixUser,
	isDeployment,
	PhoenixDeployment,
	PhoenixFeature
} from 'phoenix/domain';
import { 
	FeatureToggle, 
	AgnosticToggle,
	UserToggle,
	CurrentUserToggle,
	DeploymentToggle,
	ToggleSubject
} from 'sharebase/domain';


export class FeatureToggleFactory {
	public static $inject = [
		'pxAuthService',
		'pxPhoenixToggleService',
		'pxFeatureService'
	];
	constructor(
		private pxAuthService:AuthService,
		private pxPhoenixToggleService:PhoenixToggleService,
		private pxFeatureService:FeatureService
	){
	}

	public create(source:PhoenixFeature, subject?:ToggleSubject):FeatureToggle {
		let toggle:FeatureToggle;

		if(!subject){			
			toggle = new AgnosticToggle(this.pxFeatureService, source);
		}
		else if(isPhoenixUser(subject)){
			toggle = this.pxAuthService.user.UserId === subject.UserId ? 
				new CurrentUserToggle(this.pxPhoenixToggleService, source) :
				new UserToggle(this.pxFeatureService, source, subject);
		}
		else if(isDeployment(subject)){
			toggle = new DeploymentToggle(this.pxFeatureService, source, subject);
		}

		return toggle;
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/factories/featureToggleFactory.ts